import {
  PER_PERSON,
  ITEM_QUANTITY as STANDARD
} from 'catering/constants/quantityHandlingMethod';

export const getPrice = (
  remainingInventoryInCart,
  isSoldOut,
  price,
  minimumQuantity,
  quantityHandlingMethod,
  productHasMultipleSizes = false,
  productHasSurchargeModifier = false
) => {
  if (remainingInventoryInCart) {
    return 'Last Items In Cart';
  }

  if (isSoldOut) {
    return 'Sold Out';
  }

  let display_price = parseFloat(price);

  if (quantityHandlingMethod === STANDARD && minimumQuantity) {
    display_price *= minimumQuantity;
  }

  let suffix = '';
  if (quantityHandlingMethod === PER_PERSON) {
    suffix = ' / person';
  } else if (productHasMultipleSizes || productHasSurchargeModifier) {
    suffix = ' +';
  }

  return `$${display_price.toFixed(2)}${suffix}`;
};

export const getCalories = (
  calories,
  productHasMultipleSizes = false,
  minimumQuantity = 0
) => {
  let caloriesResult = `${calories} Cal`;

  if (productHasMultipleSizes || minimumQuantity) {
    caloriesResult = `${caloriesResult}+`;
  }

  return caloriesResult;
};
